export const syncWalletDerivedFields = (fields: Record<string, string>) => {
  const logo = fields['iosLogo'] ?? ''
  const cover = fields['iosImage'] ?? ''

  fields['androidLogo'] = logo
  fields['notificationIcon'] = logo
  fields['androidImage'] = cover
  fields['androidPointsTitle'] = fields['iosPointsTitle'] ?? ''
  fields['iosSubtitleColor'] = fields['iosTitleColor'] ?? ''
}
